import { Dispatch } from "redux";
import { StoreAction } from "../../utils/actions";
import { INotificationItem } from "../../app/modules/core/_models";

/** Set full notification list */
export const fetchNotificationDataAction =
    (notificationData: INotificationItem[] | null) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.NOTIFICATION_DATA,
                payload: notificationData,
            });
        };

/** Add single notification */
export const addNotificationAction =
    (notification: INotificationItem) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.ADD_NOTIFICATION,
                payload: notification,
            });
        };

/** Delete notification by id */
export const deleteNotificationAction =
    (id: string | number) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.DELETE_NOTIFICATION,
                payload: id,
            });
        };

/** Update notification */
export const updateNotificationAction =
    (notification: INotificationItem) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.UPDATE_NOTIFICATION,
                payload: notification,
            });
        };